export class TransactionSummary {
    averageDataArray: any[] = new Array<AverageDataArray>;
    summaryDataArray: any[] = new Array<SummaryDataArray>;
}
export class AverageDataArray
       {
          Total_Open_Count:number=0;
          Avg_Order_Count:number=0;
          User_Open_Count:number=0;
          Avg_Trade_Count:number=0;
          Avg_Total_Count:number=0;
          Avg_Open_Count:number=0;
          V_AVG_SUM_ROE:number=0;
          Curr_Order_Count:number=0;
          Curr_Route_Count:number=0;
          Curr_Trade_Count:number=0;
          Curr_Total_Count:number=0;
          Avg_CAT_Count:number=0;
          V_CURR_SUM_ROE:number=0;
          Curr_CAT_Count:number=0;
          Curr_Open_Count:number=0;
          Avg_Route_Count:number=0;
          CAT_Open_Count:number=0;
          Other_Open_Count:number=0;
          FINRA_CAT_Open_Count:number=0;
          Curr_CAIS_Count:number=0;
          Avg_CAIS_Count:number=0;
       }
    
       export class SummaryDataArray
       {
         finraIngestionROESSum:number=0;
         finraIntegrityROESSum:number=0;
         finraLinkingROESSum:number=0;
         catProcessingDate:Date= new Date();
         reportingSummaryDateTime:string="";
         finraCatSubReportDate:string="";
         reportingSummaryDataCount:number=0;
         reportingSummaryROESSum:number=0;
         finraACKROESSum:number=0;
         reportingSummaryMetaCount:number=0;
         finraCatSubMetaCount:number=0;
         finraCatSubDataCount:any=0;
         finraCatSubROESum:number=0;
         finraACKStatus: string="";
         finraFeedbackDateTime: string="";
       }
    
 